import { render, staticRenderFns } from "./BaseCardDivider.vue?vue&type=template&id=573d4bf0&scoped=true&"
import script from "./BaseCardDivider.vue?vue&type=script&lang=js&"
export * from "./BaseCardDivider.vue?vue&type=script&lang=js&"
import style0 from "./BaseCardDivider.vue?vue&type=style&index=0&id=573d4bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d4bf0",
  null
  
)

export default component.exports